import React from "react";
import RangeSlider from 'react-bootstrap-range-slider';
import 'bootstrap/dist/css/bootstrap.css'; // or include from a CDN
import 'react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css';
import CustomLabelWithInfoIcon from './CustomLabel';

const RangeScroller = ({value, setValue, label, tooltip, min, max, step, disabled}) => {

  return (
    <div className='small-container' style={{opacity: disabled ? 0.5 : 1}}>
        <CustomLabelWithInfoIcon label={label} info={tooltip}/>
        <RangeSlider
            variant='primary'
            value={value}
            min={min}
            max={max}
            step={step}
            disabled={disabled}
            onChange={(e) => setValue(Number(e.target.value))}
            tooltipPlacement='bottom'
            size='sm'
        />
    </div>
  );
}

export default RangeScroller;
